<template>
  <modal
    :show.sync="showModal"
    :modal-classes="modalClass()"
    body-classes
    @close="closeModal"
  >
    <template slot="header">
      <h5 class="subtitle" id="modalcolumns">
        Manage Columns
        <el-popover placement="top" trigger="hover" width="300" class="curp">
          <span>Selected Columns will appear in the table.</span>
          <div class="badge badge-primary" slot="reference">
            <span>?</span>
          </div>
        </el-popover>
      </h5>
    </template>

    <div>
      <div class="row mt-2 mb-1 border-bottom pb-2">
        <div class="col-6 align-self-center">
          <b-form-checkbox
            v-model="allSelected"
            :indeterminate="indeterminate"
            aria-describedby="Columns"
            aria-controls="Columns"
            @change="selectedAll"
          >
            {{ allSelected ? "UnMark All" : "Mark All" }}
          </b-form-checkbox>
        </div>
        <div class="col-6 alinmov2 align-self-center">
          <base-button
            type="link"
            class="min-button mb-0 p-0"
            @click="restoreByDefault"
            >Restore by Default</base-button
          >
        </div>
      </div>

      <div class="row py-2">
        <div
          v-for="(chunk, index) in chunkedOptions"
          :key="index"
          :class="['col-12', colClass(), colClassXL()]"
        >
          <b-form-checkbox-group
            v-model="selected"
            :options="chunk"
            name="checkbox-group"
            @change="selectColumns"
            value-field="key"
            text-field="label"
            disabled-field="settings.disabled"
            class="disabled-invisible check-md"
            aria-label="Columns"
            stacked
          >
          </b-form-checkbox-group>
          <!-- </b-col> -->
        </div>
      </div>

      <div class="text-center mb-2" v-if="selected.length < 3">
        <small class="invalid-feedback">Minimum 3 columns</small>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="outline-neutral"
        class="min-button mb-0"
        @click="closeModal()"
        >Cancel</base-button
      >

      <base-button
        type="primary"
        class="min-button mb-0 ml-auto"
        @click="saveChanges(selected)"
        >Save</base-button
      >
    </template>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "select-columns",
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    fields: {
      type: [String, Object, Array],
      description: "field table"
    },
    tableGridConfig: {
      type: [String, Object, Array],
      description: "table grid config"
    },
    madatories: {
      type: Array,
      description: "field madatories"
    }
  },
  data() {
    return {
      selected: [],
      allSelected: false,
      indeterminate: false,
      showModal: false,
      options: [],
      itemsPerColumn: ""
    };
  },
  async created() {},
  watch: {
    value: {
      handler: function(current, old) {
        this.showModal = current;
      },
      deep: true
    },
    tableGridConfig: {
      handler(newConfig) {
        this.updateOptions();
      },
      deep: true
    }
  },
  created() {
    this.updateOptions();
    this.selected = this.getColumnsKey(this.fields);
    this.allSelected = this.selected.length ? true : false;
  },
  methods: {
    updateOptions() {
      this.options = this.tableGridConfig.filter(option => {
        return option.key != "selected" && option.key != "actions";
      });
    },
    closeModal(status = false) {
      this.showModal = status;
      this.$emit("closeTableGridModal", status);
    },
    selectedAll(status) {
      this.selected = status
        ? this.tableGridConfig
            .filter(option => {
              return option.key !== "selected" && option.key !== "actions";
            })
            .map(element => element.key)
        : this.madatories;
    },
    saveChanges(selected = []) {
      let fields = this.tableGridConfig || [];
      if (selected.length >= 3) {
        let columns = ["selected", "actions"];
        columns.splice(1, 0, ...selected);
        this.showModal = false;
        this.$emit(
          "saveColumns",
          columns.map(key => {
            return fields.find(item => item.key === key);
          })
        );
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please, select minimum 3 columns.",
          icon: "flaticon-warning-1"
        });
      }
    },
    selectColumns(columns = []) {
      if (columns.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (columns.length === this.fields.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
    getColumnsKey(fields = []) {
      return fields
        .filter(option => {
          return option.key != "selected" && option.key != "actions";
        })
        .map(element => element.key);
    },
    restoreByDefault() {
      this.selected = this.tableGridConfig
        .filter(option => {
          return option.key != "selected" && option.key != "actions";
        })
        .filter(option => {
          return option.settings.default;
        })
        .map(element => element.key);
    },
    chunkArray(myArray, chunk_size) {
      const results = [];
      for (let i = 0; i < myArray.length; i += chunk_size) {
        results.push(myArray.slice(i, i + chunk_size));
      }
      return results;
    },
    colClass() {
      return (
        {
          1: "col-md-12",
          2: "col-md-6",
          3: "col-md-4"
        }[this.columns] || "col-md-12"
      );
    },
    colClassXL() {
      return (
        {
          1: "col-xl-12",
          2: "col-xl-6",
          3: "col-xl-4"
        }[this.columns] || "col-xl-12"
      );
    },
    modalClass() {
      return (
        {
          1: "modal-xs",
          2: "modal-md",
          3: "modal-lg"
        }[this.columns] || "modal-xs"
      );
    }
  },
  computed: {
    chunkedOptions() {
      return this.chunkArray(this.options, this.chunkSize);
    },
    chunkSize() {
      const totalItems = this.options.length;
      if (totalItems <= 12) {
        return totalItems; // 1 column
      } else if (totalItems <= 24) {
        return Math.ceil(totalItems / 2); // 2 columns
      } else if (totalItems <= 36) {
        return Math.ceil(totalItems / 3); // 3 columns
      } else {
        return Math.ceil(totalItems / 3); // More than 36 items, 3 columns
      }
    },
    columns() {
      const totalItems = this.options.length;
      if (totalItems <= 12) {
        return 1;
      } else if (totalItems <= 24) {
        return 2;
      } else {
        return 3;
      }
    },
    ...mapGetters(["sesion"])
  }
};
</script>
